// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bhl_vu bhl_ql bhl_va bhl_gy bhl_kg bhl_sv","ProfileAdminTools__item":"iz_b"};